export default __webpack_public_path__ + "static/media/demo-tutorial-icon.7023c4e1.svg";